const API_ROOT = {
  development: 'http://api-test.dokimoai.com',
  test: 'http://api-test.dokimoai.com',
  production: 'http://api.dokimoai.com',
}

const API_ROOT_COMMUNITYGOVERN = {
  development: 'http://test-shortvideo-api.szsttkj.com',
  test: 'http://test-shortvideo-api.szsttkj.com',
  production: 'https://api-shortvideo-xc.szxlxzb.com',
}

const API_ROOT_MEDIA = {
  development: 'http://dokimo-media-gateway.srv.aimoox.com',
  test: 'http://dokimo-media-gateway.srv.aimoox.com',
  production: 'http://dokimo-media-gateway.srv.aimoox.com',
}

const API_PREFIX = '/api'
const API_PREFIX_MEDIA = '/media-api'

// 扩展 - 目前未使用
const API_PREFIX_COMMUNITYGOVERN = `${API_PREFIX}/communitygovern`

const proxyMatch = new RegExp(`^${API_PREFIX}`)
const proxyMatchMedia = new RegExp(`^${API_PREFIX_MEDIA}`)

const proxyMatchCommunitygovern = new RegExp(`^${API_PREFIX_COMMUNITYGOVERN}`)

const roots2Proxies = (env) => [
  {
    match: proxyMatchMedia,
    map: (path) => path.replace(API_PREFIX_MEDIA, ''),
    host: API_ROOT_MEDIA[env],
  },
  {
    match: proxyMatchCommunitygovern,
    map: (path) => path.replace(API_PREFIX_COMMUNITYGOVERN, '/communitygovern'),
    host: API_ROOT_COMMUNITYGOVERN[env],
  },
  {
    match: proxyMatch,
    map: (path) => path.replace(API_PREFIX, ''),
    host: API_ROOT[env],
  },
]
module.exports = {
  project: 'agi-web',
  devPort: 7100,
  devStaticPort: 7101,
  scriptsConfig: {
    disableAutoImportAntdMobileCss: false,
  },
  production: {
    ENV: 'production',
    proxies: roots2Proxies('production'),
  },
  test: {
    ENV: 'test',
    proxies: roots2Proxies('test'),
  },
  development: {
    ENV: 'development',
    proxies: roots2Proxies('development'),
  },
}
